<template>
    <v-col cols="6" sm="4" md="3" class="d-flex">
      <div
        class="audience-selector__element"
        :class="active ? 'audience-selector__element--active' : ''"
        @click="$emit('selectCreativePath', path.value)"
        v-ripple
      >
        <v-icon large>{{ path.icon }}</v-icon>
        {{ path.title }}
      </div>
    </v-col>
</template>

<script>
  export default {
    name: 'message-selector-element',
    data () {
      return {}
    },
    props: {
      path: {
        type: Object,
        default: () => {}
      },
      active: {
        type: Boolean,
        default: false
      }
    },
    filters: {
      toUpperCase (value) {
        return value.toUpperCase()
      }
    }
  }
</script>

<style lang="scss">
$border-color: rgb(96, 153, 216);
$border-radius: 10px;
$color-text: rgb(25, 118, 210);
$background-color-hover: rgb(228, 238, 249);
$background-color-active: rgb(13, 71, 161);
$color-text-active: rgb(255, 255, 255);
$font-size: 14px;

.audience-selector__element {
  width: 100%;
  padding: .5rem;
  border: 1px solid $border-color;
  border-radius: $border-radius;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: $color-text;
  font-size: $font-size;
  .v-icon {
    margin-right: 12px;
    color: $color-text!important;
  }
  &:hover {
    background-color: $background-color-hover;
  }
  &--active {
    background-color: $background-color-active;
    border-color: $background-color-active;
    color: $color-text-active;
    pointer-events: none;
    .v-icon {
      color: $color-text-active!important;
    }
  }
}
</style>
